
export default {
    created() {

        // 默认查询数据
        this.mix_defaultQuery = {
            ...this.mix_query,
        }

        this.mix_query = {
            ...this.mix_query,
            ... this.$route.query
        }

        if (this.initData) this.initData(true)
    },
    data() {
        return {
            // 查询数据
            mix_query: {},

            // 总条数
            mix_total: 0,
            // 当前页数
            mix_page: 1,
            // 每页条数
            mix_pageSize: 20,

            // 列表数据key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',
        }
    },
    computed: {
        // 全选按钮
        mix_isSelectAll: {
            get() {

                const { mix_listKey } = this;
                const list = this[mix_listKey];

                if (!list || !list.length) {
                    return false;
                }

                const checkboxAll = list.every((item) => {
                    return item.mix_checkbox;
                })

                return checkboxAll;
            },
            set(newValue) {
                const { mix_listKey } = this;
                const list = this[mix_listKey];

                list.map((item) => {
                    item.mix_checkbox = newValue;
                })

                this[mix_listKey] = [...list];
            }
        },
        // 选择的数据列表
        mix_checkedList() {
            const { mix_listKey } = this;

            const list = this[mix_listKey];

            return list.filter((item) => {
                return item.mix_checkbox;
            })
        },
    },
    methods: {
        /**
         * 格式化列表数据
         */
        mix_format(data) {
            return data.map((v) => {
                v.mix_checkbox = false;

                return v;
            });
        },

        /**
         * 搜索
         */
        mix_search() {
            this.mix_page = 1;
            this.mix_total = 0;

            this.mix_setUrlQuery();
            this.initData();
        },

        /**
         * 重置
         */
        mix_reset() {
            let query = {
                page: this.mix_page,
                pageSize: this.mix_pageSize,
            };


            if (this.defaultQuery) {
                query = {
                    ...query,
                    ...this.mix_defaultQuery,
                }
            }

            this.mix_query = query;
            this.mix_page = 1;

            this.mix_search();
        },

        /**
         * 设置URL
         */
        mix_setUrlQuery() {

        },

        /**
         * 初始化数据
         */
        initData(ready = false) {

            // this.list = ret.data.list;
            // this.total = ret.data.total;
            // this.page = ret.data.page;
            // this.pageSize = ret.data.pageSize;

            throw new Error('使用混入的组件必须重写initData');
        },

        // 列表数据选中
        mix_selectListItem() {

        },

        // 分页切换
        mix_pageChange(page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;

            // this.mix_setUrlQuery();

            this.initData();
        },

        // 批量删除
        mix_batchDelete() {
            this.$message.success('操作成功');

            const { mix_listKey, mix_listId } = this;

            const list = [];

            this[mix_listKey].map((listItem) => {
                let deleted;
                this.mix_checkedList.map((checkedItem) => {
                    if (listItem[mix_listId] == checkedItem[mix_listId]) {
                        this.total--;
                        deleted = true;
                    }
                })

                if (!deleted) list.push(listItem)
            })

            this[mix_listKey] = list;
        },

        // 批量修改数据
        mix_batchUpdate(newItem) {
            this.$message.success('操作成功');

            const { mix_listKey, mix_listId } = this;
            const list = [];

            this[mix_listKey].map((listItem, index) => {
                // 判断是否选中数据
                let exist;
                this.mix_checkedList.map((checkedItem) => {
                    if (listItem[mix_listId] == checkedItem[mix_listId]) {
                        exist = true;
                    }
                })

                if (exist) {
                    list.push({
                        ...listItem,
                        ...newItem,
                    })

                } else {
                    list.push(listItem)
                }
            })

            this[mix_listKey] = [
                ...list
            ];
        },

        // 批量操作
        mix_batchAction(...args) {

            // 判断是否有选择的数据
            if (!this.mix_checkedList || !this.mix_checkedList.length) {
                this.$message.warning('请选择数据');
                return;
            }


            if (this.batchAction) return this.batchAction(...args);
        },

        // 操作
        mix_action(...args) {
            if (this.action) return this.action(...args);
        },

        // 删除(单条)
        mix_delete(current) {
            const { mix_listKey, mix_listId } = this;
            const list = this[mix_listKey];

            this[mix_listKey] = list.filter(v => v[mix_listId] != current[mix_listId]);
            this.mix_total--;

            this.$message.success('删除成功');
        },

        // 修改(单条)
        mix_update(index, newData) {
            const { mix_listKey } = this;
            const list = this[mix_listKey];

            list[index] = {
                ...list[index],
                ...newData
            }

            this.list = [...list];

            this.$message.success('操作成功');
        },
    },
}
